<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Pre-Invoice Disbursements</h5>
  <div class="d-flex align-items-center gap-2 ms-auto">
    <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
  </div>
</div>

<div class="modal-body p-2">

   <div class="d-flex justify-content-end mb-2">
    <button type="button" class="btn btn-success btn-sm" (click)="addFee()">
      <fa-icon [icon]="faPlus"></fa-icon> Add Disbursement
    </button>
  </div>
  <div class="table-responsive m-2">
    <table class="table table-sm table-hover mb-0 small">
      <thead>
        <tr>
          <th>Type</th>
          <th>Entered By</th>
          <th>Supplier</th>
          <th>Net</th>
          <th>VAT</th>
          <th>Klyant</th>
          <th>Invoice</th>
          <th></th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let fee of preInvoiceFees"
          [ngClass]="{
            'table-success': fee.klyantOutlayId != null,
            'table-warning': fee.klyantOutlayId == null && fee.supplierId != null,
            'table-danger': fee.supplierId == null
          }">
          <td>
            <span *ngIf="fee.description != null">{{fee.description}}</span>
            <span *ngIf="fee.description == null">{{fee.fee.description}}</span>
          </td>
          <td>{{fee.enteredByUser.fullName}}</td>
          <td>
            <span *ngIf="fee.supplierId != null">{{getSupplierName(fee.supplierId)}}</span>
            <span *ngIf="fee.supplierId == null" class="text-success" style="cursor:pointer;" (click)="selectSupplierForFeeRow(fee.preInvoiceFeeId)">
              Select Supplier... <fa-icon [icon]="faPencil"></fa-icon>
            </span>
          </td>
          <td>{{fee.netAmount | currency:'£'}}</td>
          <td>{{fee.vatAmount | currency:'£'}}</td>
          <td>{{fee.klyantStatus}}</td>
          <td>
            <span *ngIf="fee.invoiceItem?.invoice?.invoiceNumber">{{fee.invoiceItem.invoice.invoiceNumber}}</span>
          </td>
          <td>
            <fa-icon *ngIf="fee.klyantStatus != 'BILLED'" [icon]="faTimes"
              class="text-danger" style="cursor:pointer;"
              (click)="removeFee(fee)">
            </fa-icon>
          </td>
          <td>
            <fa-icon *ngIf="fee.klyantOutlayId != null" [icon]="faExternalLink"
              class="text-success" style="cursor:pointer;"
              (click)="editInKlyant(fee.klyantOutlayId)">
            </fa-icon>
            <fa-icon *ngIf="fee.supplierId != null && fee.klyantOutlayId == null && !fee.sendingToKlyant"
              [icon]="faShare" class="text-success" style="cursor:pointer;"
              (click)="sendToKlyant(fee)">
            </fa-icon>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>